<template>
  <v-form @submit.prevent="addUpdateHoliday" ref="form">
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">{{mode}} Holiday</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text>
            <p v-if="error" style="color:red;">{{ errorMessage }}</p>     
            <v-layout row wrap>
                <v-flex xs12 sm12 class="font-weight-bold" style="padding:10px 25px 0px 25px;" >
                    Calendar Year : {{fiscalYear}}
                </v-flex>
            </v-layout> 
            <v-layout row wrap>
                <v-flex xs12 sm12 style="padding:10px 25px 0px 25px;" >
                    <v-text-field label="Description" 
                        v-model="description" 
                        :rules="[rules.required]" 
                        :disabled="disabled"
                        @keyup="error=false"></v-text-field>
                    <v-menu v-if="mode=='Add'" v-model="menuHolidayDate" :close-on-content-click="false" :nudge-right="40"
                        lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="holidayDate" label="Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                        </template>
                        <v-date-picker no-title v-model="holidayDate" :allowed-dates="allowedDates" @input="menuHolidayDate = false"></v-date-picker>
                    </v-menu>
                    <v-text-field v-if="mode!='Add'" v-model="holidayDate" label="Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled" hint="Disabled if editing. Create new if different date."></v-text-field>
                    <v-select
                        :items="holiday_types"
                        :rules="[rules.required]" 
                        item-text="holidayTypeName"
                        item-value="holidayTypeId"
                        label="Holiday Type"
                        :disabled="disabled"
                        v-model="holidayTypeId"                  
                    ></v-select>
                    <v-textarea v-show="showComment" v-model="remarks" label="Remarks" rows="2" color="primary"></v-textarea>
                </v-flex>
            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions style="height:45px">
            <v-spacer></v-spacer>
            <v-btn icon @click="showComment=!showComment" title="Add Comment">
                <v-icon>comment</v-icon>
            </v-btn>
            <v-btn color="primary" type="submit" :loading="loading" style="color:white">Save</v-btn>
            <v-btn @click="clearForm" v-if="mode=='Add'" :disabled="disabled" >clear</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

import holidaysApi from '@/api/holidays'

export default {
    name: 'login-dialog',
    data () {
        return {
            error: false,
            errorMessage: '', 
            loading: false,
            disabled: false,
            error: false,    
            showComment: false,   
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                counter: value => value.length <= 20 || 'Max 20 characters',
            },
            description: '',
            menuHolidayDate: false, 
            holidayDate: null,
            holidayId: '',
            holidayTypeId: '',
            remarks: '',
            holiday_types: [],
            mode: '',
            fiscal_period: null
      }
    },
    methods: {        
        async setParamsAdd(fiscal_period){
            this.mode = 'Add'
            this.clearForm()
            this.fiscal_period = fiscal_period

            await this.getTypes()
        },
        async setParamsEdit(data, fiscal_period){
            this.mode = 'Edit'
            this.clearForm()

            if (this.holiday_types.length==0) await this.getTypes()
            
            this.fiscal_period = fiscal_period
            this.holidayId = data.holidayId
            this.description = data.description
            this.holidayDate = this.$moment(data.date).format('YYYY-MM-DD')
            this.holidayTypeId = data.holidayTypeId
            this.remarks = data.remarks
        },
        closeDialog() {
            this.$emit('update:dialogAddEdit', false)
            this.clearForm()
        },
        async getTypes(){
            try{
                this.loading = true
                const response = await holidaysApi.getTypes()
                if (response && response.status == 200) {
                    this.holiday_types = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async addUpdateHoliday() {
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true
                    
                    var data = {
                        holidayId: this.holidayId,
                        date: this.holidayDate,
                        holidayTypeId: this.holidayTypeId,
                        description: this.description,
                        remarks: this.remarks
                    }
                    var response = null
                    if (this.mode == 'Add')
                        response = await holidaysApi.add(data)
                    else 
                        response = await holidaysApi.update(data)
                        
                    if (response && response.status == 200) {
                        this.loading = false
                        this.disabled = false
                        this.closeDialog()
                        this.$emit('send', '')
                    }
                }catch(error) {
                    this.errorMessage = error
                    this.error = true
                }
            }
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        },
        allowedDates(val) {
            return this.$moment(val).format('YYYY-MM-DD') >= this.$moment(this.fiscal_period.fiscalStartDate).format('YYYY-MM-DD') && this.$moment(val).format('YYYY-MM-DD') <= this.$moment(this.fiscal_period.fiscalEndDate).format('YYYY-MM-DD')
        },
    },
    computed: {
        fiscalYear() {
            if (this.fiscal_period!=null) return this.fiscal_period.fiscalYear
        },
    },
    created() {}
}
</script>